module.exports = __webpack_public_path__ + "media/images/application/template/minus-0a2bc8acc4250d477b5bb905cba7db97.svg";